import { asyncSimpleModal } from '../../common';
import moment from '../../moment';
import { DATE_FORMAT } from '../../../types/common/date';

export const confirmWidgetPeriod = (period: { startDate: string | null; endDate: string | null }): Promise<boolean> => {
  const isPeriodSet = period.startDate && period.endDate;

  const startDate = moment(period.startDate).format(DATE_FORMAT.FULL_DASH_FORMAT);
  const endDate = moment(period.endDate).format(DATE_FORMAT.FULL_DASH_FORMAT);

  const message = isPeriodSet
    ? `해당 위젯의 노출기간은\n ${startDate}~${endDate}입니다.\n 그래도 진행하시겠습니까?`
    : '해당 위젯은 무기한으로 설정이 되어있습니다.\n 그래도 진행하시겠습니까?';
  /**
   *  위젯을 등록/편집을 할 때, 해당 위젯의 홈화면 노출 기간을 보여줌으로써
   *  잘못된 위젯 스케줄을 피하도록 함
   */
  return asyncSimpleModal({
    type: 'confirm',
    title: '홈화면 노출기간',
    message,
  });
};
